import React from 'react';
import Icon from '../../../components/AppIcon';

const MeasurementGuidance = () => {
  return (
    <div className="bg-surface rounded-lg p-6 mb-6">
      <h2 className="text-lg font-semibold text-text-primary mb-4 flex items-center">
        <Icon name="Info" className="w-5 h-5 mr-2 text-primary" />
        How to Take Accurate Height Measurements
      </h2>

      <div className="space-y-4">
        <div className="bg-card rounded-lg p-4">
          <h3 className="font-medium text-text-primary mb-2">Equipment Needed</h3>
          <ul className="space-y-2 text-text-secondary text-sm">
            <li className="flex items-start">
              <Icon name="Check" className="w-4 h-4 text-success mr-2 mt-0.5 flex-shrink-0" />
              <span>A flat wall without skirting boards</span>
            </li>
            <li className="flex items-start">
              <Icon name="Check" className="w-4 h-4 text-success mr-2 mt-0.5 flex-shrink-0" />
              <span>A hardback book or flat object</span>
            </li>
            <li className="flex items-start">
              <Icon name="Check" className="w-4 h-4 text-success mr-2 mt-0.5 flex-shrink-0" />
              <span>A tape measure or ruler</span>
            </li>
            <li className="flex items-start">
              <Icon name="Check" className="w-4 h-4 text-success mr-2 mt-0.5 flex-shrink-0" />
              <span>Pencil to mark the wall (optional)</span>
            </li>
          </ul>
        </div>

        <div className="bg-card rounded-lg p-4">
          <h3 className="font-medium text-text-primary mb-2">Measurement Steps</h3>
          <ol className="space-y-2 text-text-secondary text-sm list-decimal list-inside">
            <li>Remove shoes, thick socks, and hair accessories</li>
            <li>Stand with back against the wall, heels together</li>
            <li>Look straight ahead, not up or down</li>
            <li>Place the book flat on top of the head, perpendicular to the wall</li>
            <li>Mark or note where the book meets the wall</li>
            <li>Measure from the floor to the mark</li>
            <li>Record the measurement in centimetres</li>
            <li>Repeat immediately for a second measurement</li>
          </ol>
        </div>

        <div className="bg-info/10 border border-info rounded-lg p-4">
          <h3 className="font-medium text-text-primary mb-2 flex items-center">
            <Icon name="Clock" className="w-4 h-4 mr-2 text-info" />
            Best Practices
          </h3>
          <ul className="space-y-2 text-text-secondary text-sm">
            <li className="flex items-start">
              <span className="text-info mr-2">•</span>
              <span><strong>Same time of day:</strong> Measure at the same time each month (morning is best)</span>
            </li>
            <li className="flex items-start">
              <span className="text-info mr-2">•</span>
              <span><strong>Two measurements:</strong> Take two back-to-back measurements and record both</span>
            </li>
            <li className="flex items-start">
              <span className="text-info mr-2">•</span>
              <span><strong>Monthly frequency:</strong> Measure once per month, or fortnightly during rapid growth</span>
            </li>
            <li className="flex items-start">
              <span className="text-info mr-2">•</span>
              <span><strong>Consistency:</strong> Use the same wall and technique each time</span>
            </li>
          </ul>
        </div>

        <div className="bg-warning/10 border border-warning rounded-lg p-4">
          <div className="flex items-start">
            <Icon name="AlertTriangle" className="w-5 h-5 text-warning mr-3 mt-0.5 flex-shrink-0" />
            <div className="text-sm">
              <p className="font-medium text-text-primary mb-1">Important Reminder</p>
              <p className="text-text-secondary">Small errors can create false growth spurts in the data. If your two measurements differ by more than 2cm, please re-measure.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeasurementGuidance;